const formatoImporte = new Intl.NumberFormat("es-ES", {
  style: "currency",
  currency: "EUR",
  useGrouping: true,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

function normalizarImporte(valor) {
  if (typeof valor === "number") {
    return Number.isFinite(valor) ? valor : NaN;
  }

  const texto = String(valor ?? "")
    .trim()
    .replace(/\s/g, "")
    .replace(/€/g, "");

  if (!texto) {
    return NaN;
  }

  const tieneComa = texto.includes(",");
  const tienePunto = texto.includes(".");

  if (tieneComa && tienePunto) {
    if (texto.lastIndexOf(",") > texto.lastIndexOf(".")) {
      return Number(texto.replace(/\./g, "").replace(",", "."));
    }
    return Number(texto.replace(/,/g, ""));
  }

  if (tieneComa) {
    const partes = texto.split(",");
    if (partes.length === 2 && partes[1].length <= 2) {
      return Number(texto.replace(",", "."));
    }
    return Number(texto.replace(/,/g, ""));
  }

  return Number(texto);
}

export function formatearImporte(valor) {
  const numero = normalizarImporte(valor);

  if (!Number.isFinite(numero)) {
    return "0,00 €";
  }

  return formatoImporte.format(numero);
}

export function formatearImporteEnTexto(texto) {
  if (!texto) {
    return "";
  }

  return String(texto).replace(
    /(\d[\d.,]*)\s*€/g,
    (_, importe) => formatearImporte(importe)
  );
}

export function getCosteEtapa(reserva, etapa) {
  if (!reserva || !etapa) {
    return '0.00';
  }
  const ind = Number(reserva?.cant_habitaciones_individuales || 0);
  const dobles =
    Number(reserva?.cant_habitaciones_dobles || 0) +
    Number(reserva?.cant_habitaciones_dobles_matrimoniales || 0);
  const triples = Number(reserva?.cant_habitaciones_triples || 0);

  const tarifaInd = Number(etapa?.pivot?.tarifa_ind || 0);
  const tarifaDoble = Number(etapa?.pivot?.tarifa_doble || 0);
  const tarifaTriple = Number(etapa?.pivot?.tarifa_triple || 0);

  const total =
    tarifaInd * ind +
    tarifaDoble * dobles +
    tarifaTriple * triples;
  return total.toFixed(2);
}

export function descripcionCosteEtapa(reserva, etapa) {
  const descInd =
    reserva?.cant_habitaciones_individuales > 0 && etapa?.pivot?.tarifa_ind
      ? `${reserva.cant_habitaciones_individuales} Ind x ${formatearImporte(etapa.pivot.tarifa_ind)}`
      : '';
  const cantidadDobles =
    (Number(reserva?.cant_habitaciones_dobles || 0) +
      Number(reserva?.cant_habitaciones_dobles_matrimoniales || 0));
  const descDoble =
    cantidadDobles > 0 && etapa?.pivot?.tarifa_doble
      ? `${cantidadDobles} Doble x ${formatearImporte(etapa.pivot.tarifa_doble)}`
      : '';
  const descTriple =
    reserva?.cant_habitaciones_triples > 0 && etapa?.pivot?.tarifa_triple
      ? `${reserva.cant_habitaciones_triples} Triple x ${formatearImporte(etapa.pivot.tarifa_triple)}`
      : '';

  const partes = [descInd, descDoble, descTriple].filter((p) => p && p.trim() !== '');
  /*const total = getCosteEtapa(reserva, etapa);
  if (!partes.length) {
    return `${total} €`;
  }*/
  return `${partes.join(' + ')}`;
}

export function getTotalVentaResumen(reserva) {
  return Number(reserva?.importe_presupuestado || 0);
}

export function getCosteServicioTraslado(reserva) {
  if (!reserva) {
    return 0;
  }
  const cantPeregrinos = Number(reserva?.cant_peregrinos || 0);
  const cantEtapas = Array.isArray(reserva?.etapas) ? reserva.etapas.length - 2 : 0;
  return Number((cantPeregrinos * cantEtapas * 0).toFixed(2));
}

export function getTotalCosteEtapasResumen(reserva) {
  const etapas = Array.isArray(reserva?.etapas) ? reserva.etapas : [];
  return etapas.reduce((sum, etapa) => {
    const proveedor = etapa?.pivot?.proveedor_nombre;
    if (!proveedor) {
      return sum;
    }
    return sum + Number(getCosteEtapa(reserva, etapa) || 0);
  }, 0);
}

export function getTotalCosteServiciosResumen(reserva) {
  const servicios = Array.isArray(reserva?.servicios) ? reserva.servicios : [];
  return servicios.reduce((sum, servicio) => sum + Number(servicio?.coste || 0), 0);
}

export function getTotalCosteResumen(reserva) {
  return (
    getTotalCosteEtapasResumen(reserva) +
    getTotalCosteServiciosResumen(reserva)
  );
}

export function getGananciaResumen(reserva) {
  return getTotalVentaResumen(reserva) - getTotalCosteResumen(reserva);
}

export function getPorcentajeVentaCoste(reserva) {
  const totalVenta = getTotalVentaResumen(reserva);
  if (!totalVenta) {
    return 0;
  }
  return (getGananciaResumen(reserva) / totalVenta) * 100;
}

export function getReservaClienteNombre(reserva) {
  const nombre = String(reserva?.cliente?.nombre || "").trim();
  const apellidos = String(reserva?.cliente?.apellidos || "").trim();
  const nombreCompleto = [nombre, apellidos].filter(Boolean).join(" ").trim();

  return nombreCompleto || "Sin cliente";
}

export function getReservaCaminoTitulo(reserva) {
  return String(reserva?.camino?.titulo || "").trim() || "Sin camino";
}

export function getReservaEstadoNombre(reserva) {
  return String(reserva?.estado?.estado || "").trim();
}

export function getReservaEstadoColor(reserva) {
  return String(reserva?.estado?.color || "").trim() || "transparent";
}
